import '../scss/timeline.scss';

const timelineContainer = document.querySelector('.timeline');
const scrollBarContainer = document.querySelector('.scroll-element-container');
const scrollBar = document.querySelector('.scroll-bar');

scrollBar.style.height = '450px';

const fullYOffset = timelineContainer.scrollHeight - timelineContainer.clientHeight // Here we get the domain, we'll need to map this to the range
const maxYOffset = timelineContainer.clientHeight - (450) // Here we get the range

const ratio = maxYOffset / fullYOffset  // In order to map the range to the domain, we can use this ratio

timelineContainer.addEventListener("scroll", e => {
    const scrollY = e.target.scrollTop;
    
    // const fullYOffset = e.target.scrollHeight - e.target.clientHeight // Here we get the domain, we'll need to map this to the range
    // const maxYOffset = timelineContainer.clientHeight - (450) // Here we get the range

    // const ratio = maxYOffset / fullYOffset // In order to map the range to the domain, we can use this ratio

    const scrollYFinial = ( scrollY * ratio ) < maxYOffset ?  scrollY * ratio : maxYOffset // Set an upper limit
    scrollBar.style.transform = 'translate(0, ' + scrollYFinial +'px)';
});



// Get an element's distance from the top of the page
const getElemDistance =  elem => {
    let location = 0;
    if ( elem.offsetParent ) {
        do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
        } while ( elem );
    }
    return location >= 0 ? location : 0;
};

const location = getElemDistance( timelineContainer );

let isDown = false
let startY
let scrollTop
let previousWalk = 0

scrollBar.addEventListener('mousedown', e => {
    isDown = true
    startY = e.pageY - location
    scrollTop = timelineContainer.scrollTop
    scrollBar.classList.add('active')
})
timelineContainer.addEventListener('mouseleave', () => {
    isDown = false
    scrollBar.classList.remove('active')
})
scrollBar.addEventListener('mouseup', () => {
    isDown = false
    scrollBar.classList.remove('active')
})
scrollBar.addEventListener('mousemove', e => {
    if( !isDown ) return
    e.preventDefault()
    const y = e.pageY - location
    
    // console.log('mouse start pos', startY)
    let walk = y - startY
    // console.log('walk', walk)
    // if( walk < 0 ) walk = 0
    const timeLineScrollTop = timelineContainer.scrollTop

    // console.log('scrolltop', timeLineScrollTop )

    timelineContainer.scrollTop = timeLineScrollTop + (walk/10)
    // const scrollYFinial = ( timeLineScrollTop * ratio ) < maxYOffset ?  timeLineScrollTop * ratio : maxYOffset // Set an upper limit
    // scrollBar.style.transform = 'translate(0, ' + scrollYFinial +'px)';
});


(function($) {
    $(document).ready(function() {

        if(window.innerWidth > 700) {
            $('.timeline-item:nth-child(odd)').addClass('odd');
            $('.timeline-item:nth-child(even)').addClass('even');

            $('.odd').appendTo('.timeline-left');
            $('.even').appendTo('.timeline-right');
        };
    })

})(jQuery);